<mat-card class="matcardcontent">
    <mat-card-header>
        <mat-card-title>Lista lavorazioni per la commessa: {{codicecommessa}} ({{nomestatocommessa}})</mat-card-title>
    </mat-card-header>
    <mat-card-content>
<!--      <form>-->


           <mat-form-field appearance="fill" style="padding-right: 10px">
             <mat-label class="text-sm">Stato</mat-label>
             <mat-select [(ngModel)]="selectedValueStato" name="stato" (selectionChange)="manageChangeStato()" class="text-sm">
               <mat-option *ngFor="let stato of stati" [value]="stato.Nome">
                 {{stato.Nome}}
               </mat-option>
             </mat-select>
           </mat-form-field>


  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

    <ng-container matColumnDef="Codice">
        <th [style.display]="getConfigurazione().Codice" mat-header-cell *matHeaderCellDef>Codice
          <img src="./assets/images/sort.png" (click)="manageClick('Codice')"/>
        </th>
        <td [style.display]="getConfigurazione().Codice" mat-cell *matCellDef="let lavorazione"> {{lavorazione.Codice}} </td>
    </ng-container>

    <ng-container matColumnDef="Nome">
        <th [style.display]="getConfigurazione().Nome" mat-header-cell *matHeaderCellDef>Nome
          <img src="./assets/images/sort.png" (click)="manageClick('Nome')"/>
        </th>
        <td [style.display]="getConfigurazione().Nome" mat-cell *matCellDef="let lavorazione"> {{lavorazione.Nome}} </td>
    </ng-container>

    <ng-container matColumnDef="Stato">
        <th [style.display]="getConfigurazione().Stato" mat-header-cell *matHeaderCellDef>Stato
      <!--    <img src="./assets/images/sort.png" (click)="manageClick('Stato')"/> -->
        </th>
        <td [style.display]="getConfigurazione().Stato" mat-cell *matCellDef="let lavorazione"> {{lavorazione.Statolavorazione.Nome}} </td>
    </ng-container>

    <ng-container matColumnDef="articolilavorazione">
        <th mat-header-cell *matHeaderCellDef> Materiali </th>
        <td mat-cell *matCellDef="let lavorazione">
          <mat-icon color="primary" (click)="articolilavorazione(lavorazione)">storage</mat-icon>
        </td>
    </ng-container>

      <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef> Modifica </th>
          <td mat-cell *matCellDef="let lavorazione">
            <mat-icon color="primary" (click)="edit(lavorazione)">create</mat-icon>
          </td>
      </ng-container>

      <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef> Elimina </th>
          <td mat-cell *matCellDef="let lavorazione">
            <mat-icon color="primary" (click)="delete(lavorazione)">delete</mat-icon>
          </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator #paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>

<!-- </form> -->
</mat-card-content>
<mat-card-actions>
  <table>
    <tr>
      <td>
        <button mat-raised-button  color="primary" (click)="new()">Nuova lavorazione</button>
      </td>
      <td>
        <button mat-raised-button  color="primary" (click)="cancel()">Cancella</button>
      </td>
      <td>
        <button mat-raised-button  color="primary" (click)="back()">Indietro</button>
      </td>
    </tr>
  </table>
</mat-card-actions>

</mat-card>
